// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30ctU","right":"styles_right__3x81V"};